if (!customElements.get('complete-look')) {
  customElements.define(
    'complete-look',
    class CompleteLook extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {   
        const optionSelect = this.querySelectorAll('[data-option-select]');
        const mainSelect = this.querySelector('[data-main-select]');
        const addToCartButton = this.querySelector('[data-action="add-to-cart"]');
        const pic = this.querySelector('img');


        const checkVariantAvailability = () => {
          const selectedOptions = Array.from(optionSelect).map(select => select.value);
          const selectedVariant = Array.from(mainSelect.options).find(option => 
            selectedOptions.every(selectedOption => option.text.includes(selectedOption))
          );

          if (selectedVariant) {
            mainSelect.value = selectedVariant.value;
            addToCartButton.disabled = selectedVariant.dataset.available !== 'true';
          } else {
            addToCartButton.disabled = true;
          }
          pic.removeAttribute('srcset');
          pic.setAttribute('src', mainSelect.querySelector('option:checked')?.getAttribute('data-image'));
        };

        optionSelect.forEach(select => {
          select.addEventListener('change', checkVariantAvailability);
        });

        checkVariantAvailability();

        addToCartButton.addEventListener('click', () => {
          setTimeout(() => {
            this.querySelector('[id^="ModalClose-"]').click();  
          }, 500);
        });
      }
    }
  );
}